export const WithDebug = (Base) => {
    return class PlayerWithDebug extends Base {
        setStatsForNerds(enabled) {
            enabled;
            this._logger?.info('not implemented: setStatsForNerds');
        }
    };
};
